import React, { useState } from 'react';
import { Eyebrow } from './Eyebrow';
import { FaqItem } from './FaqItem';
import { faqs } from '../data/content';
import { contact } from '../data/site';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-heading" className="bg-paper py-14 md:py-28" data-id="element-62" data-mp="1gjltxlzvh6d6">
      <div className="mx-auto grid max-w-[1320px] gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12" data-id="element-63" data-mp="1glgbcqbxqgci">
        <div className="lg:col-span-4" data-id="element-64" data-mp="28aru22flf42g">
          <Eyebrow data-id="element-65" data-mp="289qb7bsc5da6">Questions</Eyebrow>
          <h2 id="faq-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-[0.95] text-ink md:text-[52px]" data-id="element-66" data-mp="28cw1gucpal7h">
            Before you request a quote.
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-steel" data-id="element-67" data-mp="2n8bxv60r6t71">
            Still have a question?{' '}
            <a href={contact.phoneHref} className="font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4" data-id="element-68" data-mp="2rzagwdd4m5dz">
              Call {contact.phoneDisplay}
            </a>
          </p>
        </div>
        <div className="border-t border-line lg:col-span-8" data-id="element-69" data-mp="10rm33bs9zvfj">
          {faqs.map((faq, i) => <FaqItem key={faq.question} id={`faq-${i}`} faq={faq} open={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-70" data-mp="1en6me8bx2fnh" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}